/* RESPONSIBLE TEAM: team-frontend-tech */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class DetailRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(DetailRoute);
